import React, { forwardRef, useState } from "react";
import classNames from "classnames/bind";
import { Chatbot } from "../../../../assets/svg";
import QuillEditor from "../../../../components/QuillEditor/QuillEditor";
import UploadCvModal from "../Modal/UploadCvModal";
import styles from "./index.module.sass";

const cx = classNames.bind(styles);

const JdSection = ({ icon, title, content }) => (
  <div className={cx("jdSection")}>
    <h4>
      <span className={cx("jdSectionIcon")}>{icon}</span>
      {title}
    </h4>
    <QuillEditor value={content} className={cx("jdQuill")} />
  </div>
);

const CampaignJdMessage = forwardRef(
  (
    {
      campaign,
      showApplyButton,
      campaignId,
      candidateId,
      uploadContext,
      onCvUploaded,
      onApply,
    },
    ref,
  ) => {
    const [uploadOpen, setUploadOpen] = useState(false);

    const handleApplyClick = () => {
      setUploadOpen(true);
    };

    const handleUploadSuccess = (uploadResult) => {
      onCvUploaded?.(uploadResult);
      onApply?.();
    };

    return (
      <div ref={ref} className={cx("messageRow", "bot", "jdMessageRow")}>
        <div className={cx("jdMessageAvatar")} aria-hidden="true">
          <Chatbot />
        </div>
        <div className={cx("jdMessageCard")}>
          <div className={cx("jdMessageHead")}>
            <h3>{campaign.title}</h3>
            <p>{campaign.department}</p>
          </div>
          <div className={cx("jdMessageBody")}>
            <JdSection
              icon="💼"
              title="Mô tả công việc"
              content={campaign.description}
            />
            <JdSection
              icon="📋"
              title="Yêu cầu ứng viên"
              content={campaign.requirements}
            />
            <JdSection icon="🎁" title="Quyền lợi" content={campaign.benefits} />
            <JdSection
              icon="🕐"
              title="Thời gian làm việc"
              content={campaign.workingTime}
            />
          </div>
          {showApplyButton && (
            <button
              type="button"
              className={cx("applyButton", "jdApplyButton")}
              onClick={handleApplyClick}
            >
              <span className={cx("applyIcon")}>📄</span>
              Ứng tuyển ngay
            </button>
          )}
        </div>

        <UploadCvModal
          open={uploadOpen}
          onClose={() => setUploadOpen(false)}
          campaignId={campaignId}
          candidateId={candidateId}
          uploadContext={uploadContext}
          onSuccess={handleUploadSuccess}
        />
      </div>
    );
  },
);

CampaignJdMessage.displayName = "CampaignJdMessage";

export default CampaignJdMessage;
